module.exports = __webpack_public_path__ + "img/01.d620da1b.jpg";